import type { ReactNode } from 'react';
import { cn } from '../../utils/cn';

type BadgeVariant = 'neutral' | 'accent' | 'success' | 'warning' | 'danger';

const variantClasses: Record<BadgeVariant, string> = {
  neutral: 'bg-border/60 text-text-secondary',
  accent: 'bg-accent-100 text-accent-600',
  success: 'bg-success-100 text-success-500',
  warning: 'bg-warning-100 text-warning-900 border border-warning-500/30',
  danger: 'bg-danger-100 text-danger-500 border border-danger-500/20',
};

export function Badge({ variant = 'neutral', children, className }: { variant?: BadgeVariant; children: ReactNode; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded text-[9px] font-black uppercase tracking-widest shrink-0',
        variantClasses[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
